import React from 'react';

const UploadStatusBar = ({ uploadStatus, uploadProgress, onClear }) => {
  if (!uploadStatus) return null;

  return (
    <>
      <div style={{
        padding: '0.75rem', borderRadius: '4px', marginBottom: '0.5rem',
        backgroundColor: uploadStatus.status === 'success' ? 'var(--success-light)' : uploadStatus.status === 'error' ? 'var(--danger-light)' : 'var(--info-light)',
        color: uploadStatus.status === 'success' ? 'var(--success)' : uploadStatus.status === 'error' ? 'var(--danger)' : 'var(--info)',
        border: `1px solid ${uploadStatus.status === 'success' ? 'var(--success-light)' : uploadStatus.status === 'error' ? 'var(--danger-light)' : 'var(--info-light)'}`
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: uploadStatus.status === 'uploading' ? '0.5rem' : 0 }}>
          <span style={{ fontSize: '12px', fontWeight: '500' }}>
            {uploadStatus.status === 'uploading' && '⏳'}{' '}
            {uploadStatus.status === 'success' && '✅'}{' '}
            {uploadStatus.status === 'error' && '❌'} {uploadStatus.message}
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            {uploadStatus.status === 'uploading' && (
              <span style={{ fontSize: '12px', fontWeight: '700', color: 'var(--info)' }}>{uploadProgress}%</span>
            )}
            <button onClick={onClear}
              style={{ background: 'none',  cursor: 'pointer', fontSize: '16px', color: 'var(--text-secondary)' }}>×</button>
          </div>
        </div>
        {uploadStatus.status === 'uploading' && (
          <div style={{
            width: '100%',
            height: '8px',
            backgroundColor: 'var(--info-light)',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${uploadProgress}%`,
              height: '100%',
              backgroundColor: 'var(--primary)',
              borderRadius: '4px',
              transition: 'width 0.5s ease-in-out',
              background: 'linear-gradient(90deg, var(--info) 0%, var(--info) 50%, var(--info) 100%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 1.5s infinite'
            }}></div>
          </div>
        )}
      </div>

      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </>
  );
};

export default UploadStatusBar;
